<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12 col-md-3 col-lg-3 col-xl-4 custom-width-desktop">
        <div class="scrollable-container">
          <div class="scrollable-div bg-light shadow-lg rounded-lg p-2">
            <div class="text-center">
              <h2>
                Der Saugroboter-Finder
                <img src="https://findingo.de/wp-content/uploads/2024/12/cropped-logo_small.png" class="img-fluid"
                  style="width: 20%;" alt="...">
              </h2>
                <h4 class="h4 mt-2" style="font-family:Open Sans,Arial,sans-serif">
    Zu viel Technik? Dann probiere die 
    <a href="https://findingo.de/saugroboter/saugroboter-kaufberatung/"
      style="font-size:1.3rem;color: #007bff; text-decoration: underline; position: relative">
      smarte Saugroboter-Kaufberatung</a>
    <span style="
        background-color: #ff3b30; 
        color: white; 
        font-weight: bold; 
        font-size: 0.7rem; 
        padding: 1px 5px; 
        border-radius: 6px; 
        position: relative; 
        top: -0.6em; 
        margin-left: 4px;
    ">NEW</span>
    aus!
  </h4>
            </div>
            <form method="GET" name="finder-form" id="finder-form" @change="onFormChange">
              <div class="formContent p-2">
                <div class="row row-cols-2">
                  <div class="ml-2 mb-3 w-[80%]">
  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
    Hersteller
  </span>
  <select v-model="filters.brand" id="brand" name="brand" class="spanSelectField form-select form-select-lg mb-1">
    <option value="Alle" selected>Alle</option>
    <option value="AEG">AEG</option>
    <option value="Dreame">Dreame</option>
    <option value="ECOVACS">ECOVACS</option>
    <option value="Eufy">Eufy</option>
    <option value="Eureka">Eureka</option>
    <option value="Ezviz">Ezviz</option>
    <option value="HOBOT">Hobot</option>
    <option value="Kärcher">Kärcher</option>
    <option value="Medion">Medion</option>
    <option value="Mova">Mova</option>
    <option value="Narwal">Narwal</option>
    <option value="Philips">Philips</option>
    <option value="Proscenic">Proscenic</option>
    <option value="Roborock">Roborock</option>
    <option value="Roidmi">Roidmi</option>
    <option value="Rowenta">Rowenta</option>
    <option value="SwitchBot">SwitchBot</option>
    <option value="UBPet">UBPet</option>
    <option value="Xiaomi">Xiaomi</option>
    <option value="Zaco">Zaco</option>
  </select>
</div>

                  <div class="ml-2 mb-3 w-[80%]">
                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                      Release
                    </span>
                    <select v-model="filters.release_date" id="release_date" name="release_date" class="spanSelectField form-select form-select-lg mb-1">
                    <option value="Alle" selected>Alle</option>
                    <option value="2025">2025</option>
                    <option value="2024">2024</option>
                  </select>
                  </div>
                  
                
                    <div class="ml-2 mb-3 w-[80%]">

                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Reinigungsstation</span>

                    <select v-model="filters.hatReinigungsstation" id="hatReinigungsstation" name="hatReinigungsstation"
                      class="spanSelectField form-select form-select-lg mb-1">

                      <option value="Alle" selected>Alle</option>
                      <option value="mit_absaugstation">Mit Absaugstation</option>
                      <option value="mit_reinigungsstation">Mit Reinigungsstation</option>
                      <option value="mit_waschsaug_reinigungsstation">Mit Saug- bzw. Waschstation</option>
                      <option value="mit_wasseranschluss">Mit Wasseranschluss</option>
                    </select>
                  </div>

                  <div class="ml-2 mb-3 w-[80%]">

                    <span
                      class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color ">Wischfunktion</span>

                    <select v-model="filters.hatWischfunktion" id="hatWischfunktion" name="hatWischfunktion"
                      class="spanSelectField form-select form-select-lg mb-1">

                      <option value="Alle" selected>Alle</option>
                      <option value="Hat_Wischfunktion">Allgemein mit Wischfunktion</option>
                      <option value="Vibrierender_Mopp">mit Mopp, der vibriert</option>
                      <option value="Rotierender_Mopp">mit Mopp, der rotiert</option>
                      
                    </select>
                  </div>

                  <div class="ml-2 mb-3 w-[80%]">
                    <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                    Geeignet für
                  </span>

                  <select v-model="filters.geeignetFuer" id="geeignetFuer" name="geeignetFuer" class="spanSelectField form-select form-select-lg mb-1">
                    <option value="Alle" selected>Alle</option>
                    <option value="Hartböden">Hartböden</option>
                    <option value="Haustiere">Haustiere/viele Haare</option>
                    <option value="Teppichböden">Teppichböden</option>
                    <option value="Ueber_100qm">ab 100 qm</option>
                  </select>
                  </div>

                  <div class="ml-2 mb-3 w-[80%]">
                    <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                    Sprachassistent
                  </span>

                  <select v-model="filters.sprachassistent" id="sprachassistent" name="sprachassistent" class="spanSelectField form-select form-select-lg mb-1">
                    <option value="Alle" selected>Alle</option>
                    <option value="Alexa">Amazon Alexa</option>
                    <option value="Google">Google Assistant</option>
                    <option value="Siri">Siri</option>
                    <option value="Herstellereigen">Eigene</option>
                  </select>
                  </div>

                                    <div class="ml-2 mb-3 w-[80%]">
                    <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
                    Hinderniserkennung
                  </span>

                  <select v-model="filters.hinderniserkennung" id="hinderniserkennung" name="hinderniserkennung" class="spanSelectField form-select form-select-lg mb-1">
                    <option value="Alle" selected>Alle</option>
                    <option value="Kamera">Kamera</option>
                    <option value="Kreuzlaser">Kreuzlaser</option>
                    
                  </select>
                  </div>

                    
                  <div class="ml-2 mb-3 w-[80%]">
  <span class="spanField small fw-semibold d-inline-block mt-1 py-1 px-2 text-uppercase text-black bg-cs-color">
    Navigationsart
  </span>
  <select 
    v-model="filters.navigation" 
    id="navigation" 
    name="navigation" 
    class="spanSelectField form-select form-select-lg mb-1"
  >
    <option value ="Alle" selected>Alle</option>
    <option value="LDS">LiDAR (Turm) empfohlen</option>
    <option value="Kamera">Kamera</option>
  </select>
</div>


                </div>
              

                <h5 class="mt-4">Preis</h5>
                <div class="mt-5" id="slider"></div>
                <input type="text" id="minCost" readonly hidden>
                <input type="text" id="maxCost" readonly hidden>
                
                <h5 class="mt-4">Saugleistung</h5>
                <div class="mt-5" id="saugleistung-slider"></div>
                <input type="text" id="minSaugleistung" readonly hidden>
                <input type="text" id="maxSaugleistung" readonly hidden>


                <div class="mt-3">
                <details open>
                  <summary>Weitere Eigenschaften</summary>
                  <div class="container">
                    <div class="row row-cols-2">
                      <div class="col-md-6 d-flex mb-4">
                        <div class="form-check form-switch d-flex">
                          <input class="form-check-input me-2" type="checkbox" id="anhebbarTeppich" v-model="filters.anhebbarTeppich" value="1" true-value="1" false-value="0">
                          <label class="form-check-label" for="anhebbarTeppich">Anhebbar auf Teppich</label>
                        </div>
                      </div>

                      <div class="col-md-6 d-flex mb-4">
                        <div class="form-check form-switch d-flex">
                          <input class="form-check-input me-2" type="checkbox" id="schmutzerkennung" v-model="filters.schmutzerkennung" value="1" true-value="1" false-value="0">
                          <label class="form-check-label" for="schmutzerkennung">Schmutzerkennung</label>
                        </div>
                      </div>

                      <div class="col-md-6 d-flex mb-4">
                        <div class="form-check form-switch d-flex">
                          <input class="form-check-input me-2" type="checkbox" id="teppicherkennungSaugen" v-model="filters.teppicherkennungSaugen" value="1" true-value="1" false-value="0">
                          <label class="form-check-label" for="teppicherkennungSaugen">Teppicherkennung (Saugen)</label>
                        </div>
                      </div>

                      <div class="col-md-6 d-flex mb-4">
                        <div class="form-check form-switch d-flex">
                          <input class="form-check-input me-2" type="checkbox" id="hatApp" v-model="filters.hatApp" value="1" true-value="1" false-value="0">
                          <label class="form-check-label" for="hatApp">App-Steuerung</label>
                        </div>
                      </div>

                      <div class="col-md-6 d-flex mb-4">
                        <div class="form-check form-switch d-flex">
                          <input class="form-check-input me-2" type="checkbox" id="virtuelleGrenzen" v-model="filters.virtuelleGrenzen" value="1" true-value="1" false-value="0">
                          <label class="form-check-label" for="virtuelleGrenzen">Virtuelle Grenzen</label>
                        </div>
                      </div>

                      <div class="col-md-6 d-flex mb-4">
                        <div class="form-check form-switch d-flex">
                          <input class="form-check-input me-2" type="checkbox" id="dreiDKarte" v-model="filters.dreiDKarte" value="1" true-value="1" false-value="0">
                          <label class="form-check-label" for="dreiDKarte">3D-Karte</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </details>
              </div>
              
                <div class="form-footer mt-2">
                  <button type="reset" class="btn btn-secondary btn-sm px-4 py-2">Auswahl zurücksetzen</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-9 col-lg-9 col-xl-8">
  <div v-if="loading" class="loading-spinner"></div>
  <div v-else class="pt-4">
    
    <div class="row g-4">
      <div
        v-for="(product, index) in products"
        :key="product.id"
        class="col-12 col-sm-6 col-lg-4 mb-4"
        :class="getCardAnimationClass(index)"
      >
        <div class="card" :class="{ 'is-flipped': isFlipped(index) }">
          
          <div class="card-front">
            <h5 class="card-title text-center mt-3 mx-5">
              {{ product.amazonNamenSuche }}
            </h5>
            <pic-carousel :product="product" />
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-sm-6">
                  <div class="d-flex flex-column">
                    <span class="label-data-front mx-2">Maße in cm (LxBxH)</span>
                    <span
        class="ml-2"
        v-if="Number(product.laenge_roboter_cm) && Number(product.breite_roboter_cm) && Number(product.hoehe_roboter_cm)"
      >
        {{ product.laenge_roboter_cm }}×{{ product.breite_roboter_cm }}×{{ product.hoehe_roboter_cm }}
      </span>
      <span class="ml-2" v-else>keine Angabe</span>
                    <span class="label-data-front mx-2 mt-2">Saugleistung</span>
                    <span class="ml-2">{{ product.saugleistung_pa }} pa</span>
                  </div>
                </div>
                <div class="col-12 col-sm-6">
                  <div class="d-flex flex-column">
                    <span class="label-data-front mx-2">Lautstärke</span>
                    <span class="ml-2" v-if="Number(product.lautstaerke_db)">{{ product.lautstaerke_db }} dB</span>
                    <span class="ml-2" v-else>keine Angabe</span>
                    <span class="label-data-front mx-2 mt-2">Staubbehälter</span>
                    <span class="ml-2" v-if="Number(product.staubbehaelter_ml)">{{ product.staubbehaelter_ml }} ml</span>
                    <span class="ml-2" v-else>keine Angabe</span>
                  </div>
                </div>
              </div>
            </div>
            <button class="datasheet-button" @click="flipCard(index)">
              <i class="fa-solid fa-rotate-right icon-margin-right"></i>
              Daten aufklappen
            </button>
            <div class="card-footer">
              <div class="footer-content d-flex justify-content-between">
                <div class="shop-info">
                  <span class="no_click" style='text-align: left;'>Amazon.de</span>
                  <div class="text-muted small" style='text-align: left; font-size: 12px;'>
                    aktualisiert: {{ product.updated_time }}
                  </div>
                </div>
                <div class="amazon-info">
                  <div class="pb-2">
                    <div class="no_click pb-1" style="text-align:left;">
                  <img class="shop-icon" src="/wp-content/plugins/tv-finder/amazon_icon.png" alt="Amazon Logo" style="margin-right: 4px;" />
                  <span class="mr-2">| </span>
                  <span class="price">{{ Number(String(product.preisAmazonNeu).replace(',', '.'))
      .toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) }}</span><br/>
                  <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
                    <button class="btn12 px-3 py-1">zum Angebot*</button>
                  </a>
                </div>
                </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="card-back">
            <div class="card-body">
              <DatenblattMod :product="product" />
            </div>
            <button class="datasheet-button" @click="flipCard(index)">
              <i class="fa-solid fa-rotate-left icon-margin-right"></i>
              Zurück zur Übersicht
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

      <div class="text-center">
        <button class="datasheet-button" @click="updateTv">
          Mehr Saugroboter laden
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import PicCarousel from "./PicCarousel.vue";
import DatenblattMod from "./DatenblattMod.vue";

export default {

  components: {
    PicCarousel,
    DatenblattMod,
  },
  name: 'SaugroboterFinderApp',
  props: {

  },


  data() {
    return {
      flippedCards: [], 
      products: [],
      loading: false,
      loadedProducts: [],
      productsPerLoad: 9, 
      loadedProductIndex: 9,

      filters: {
        brand: 'Alle',
        resolution: 'Alle',
        size: '0',
        display: 'Alle',
        inputLag: '0',
        reaktionszeit: '0',
        frequenzVertikal: '0',
        hdr: 'Alle',
        hdmi_2_1: '0',
        minPrice: '150',
        maxPrice: '2500',
        farbe: "Alle",
        energieklasse: "Alle",
        technologie: 'Alle',
        isVesa: "2",
        kontrastStatisch: "0",
        isSubwoofer: "2",
        spitzenhelligkeit: "0",
        ambilight: "2",
        betriebssystem: "Alle",
        ethernet_rj45: "0",
        ppi: "0",

        minSaugleistung: '1500',
        maxSaugleistung: '30000',
        release_date: 'Alle',
        navigation: 'Alle',
        hinderniserkennung: 'Alle',
        geeignetFuer: 'Alle',
        sprachassistent: 'Alle',
        hatWischfunktion: 'Alle',
        aktiveWasserzufuhr: '0',
        rotierend: '0',
        vibrierend: '0',
        anhebbarTeppich: '0',
        hatReinigungsstation: 'Alle',
        saugWaschstation: '0',
        wasseranschluss: '0',
        schmutzerkennung: '0',
        teppicherkennungSaugen: '0',
        hatApp: '0',
        virtuelleGrenzen: '0',
        dreiDKarte: '0',
      },
            ui: { navOpen: false },
      navOptions: [
        { value: "LDS", label: "LDS (Laserdistanz)" },
        { value: "ToF", label: "ToF (Time of Flight)" },
        { value: "Kamera", label: "Kamera-basiert" },
      ],
    };
  },
  methods: {

    navLabel(v) {
      const o = this.navOptions.find((o) => o.value === v);
      return o ? o.label : v;
    },
    toggleNav(v) {
      const i = this.filters.navigation.indexOf(v);
      if (i === -1) this.filters.navigation.push(v);
      else this.filters.navigation.splice(i, 1);
    },
    removeNav(v) {
      const i = this.filters.navigation.indexOf(v);
      if (i !== -1) this.filters.navigation.splice(i, 1);
    },
    clearNav() {
      // Bedeutet „Alle“ (kein Filter)
      this.filters.navigation = [];
    },
    selectAllNav() {
      this.filters.navigation = this.navOptions.map((o) => o.value);
    },
    handleDocClick(e) {
      const root = this.$refs.navRoot;
      if (root && !root.contains(e.target)) this.ui.navOpen = false;
    },

    initializeSlider() {
      var slider = document.getElementById('slider');
      noUiSlider.create(slider, {
        connect: true,
        behaviour: 'tap',
        start: [this.filters.minPrice, this.filters.maxPrice],
        format: wNumb({
          decimals: 0,
          suffix: ' (€)',
        }),
        tooltips: true,
        range: {
          'min': [50],
          '85%': [1500, 50],
          '95%': [2000, 500],
          'max': [2500]
        }
      });

      slider.noUiSlider.on('change', () => {
        this.filters.minPrice = parseInt(slider.noUiSlider.get()[0].replace(' (€)', ''));
        this.filters.maxPrice = parseInt(slider.noUiSlider.get()[1].replace(' (€)', ''));
        this.fetchProducts(this.filters);
      });

      var minCostInput = document.getElementById('minCost');
      var maxCostInput = document.getElementById('maxCost');

      minCostInput.addEventListener('change', () => {
        slider.noUiSlider.set([minCostInput.value.replace(' (€)', ''), null]);
      });

      maxCostInput.addEventListener('change', () => {
        slider.noUiSlider.set([null, maxCostInput.value.replace(' (€)', '')]);
      });

      // Saugleistung Slider
      var saugleistungSlider = document.getElementById('saugleistung-slider');
                    noUiSlider.create(saugleistungSlider, {
                        connect: true,
                        behaviour: 'tap',
                        start: [this.filters.minSaugleistung, this.filters.maxSaugleistung],
                        format: wNumb({
                            decimals: 0,
                            suffix: ' (Pa)',
                        }),
                        tooltips: true,
                        range: {
                            'min': [2000],
                            'max': [30000]
                        }
                    });

                    saugleistungSlider.noUiSlider.on('change', () => {
                        this.filters.minSaugleistung = parseInt(saugleistungSlider.noUiSlider.get()[0].replace(' (Pa)', ''));
                        this.filters.maxSaugleistung = parseInt(saugleistungSlider.noUiSlider.get()[1].replace(' (Pa)', ''));
                        this.fetchProducts(this.filters);
                    });

                    var minSaugleistungInput = document.getElementById('minSaugleistung');
                    var maxSaugleistungInput = document.getElementById('maxSaugleistung');

                    minSaugleistungInput.addEventListener('change', () => {
                        saugleistungSlider.noUiSlider.set([minSaugleistungInput.value.replace(' (Pa)', ''), null]);
                    });

                    maxSaugleistungInput.addEventListener('change', () => {
                        saugleistungSlider.noUiSlider.set([null, maxSaugleistungInput.value.replace(' (Pa)', '')]);
                    });
    },

    onFormChange() {
      this.fetchProducts(this.filters);
    },

    fetchProducts(filters) {
      this.loading = true;
      this.loadedProductIndex = 9;
      $.ajax({
        url: '/wp-content/plugins/saugroboter-finder/testNeuFinderApp.php',
        method: 'POST',
        dataType: 'json',
        data: {
          filters: filters,
          limit: this.loadedProductIndex
        },
        success: (response) => {
          this.loading = false; 
          this.products = response.filteredProducts;
        },
        error: (xhr, status, error) => {
        }
      });
    },

    flipCard(index) {
      const cardIndex = this.flippedCards.indexOf(index);
      if (cardIndex === -1) {
        this.flippedCards.push(index);
      } else {
        this.flippedCards.splice(cardIndex, 1);
      }
    },

    isFlipped(index) {
      return this.flippedCards.includes(index);
    },

    getCardAnimationClass(index) {
      const delay = (index + 1) * 25;
      return `animate__animated animate__fadeInUp animate__${delay}ms`;
    },

    updateTv() {
      this.loadedProductIndex += 9;
      $.ajax({
        url: "/wp-content/plugins/saugroboter-finder/testNeuFinderApp.php",
        method: "POST",
        data: {
          filters: this.filters,
          limit: this.loadedProductIndex
        },
        dataType: "json",
        success: (response) => {
          this.products = response.filteredProducts;
        },
        error: (error) => {
        },
      });
    }
  },

  mounted() {
    this.initializeSlider();
    this.fetchProducts(this.filters);
    document.addEventListener("click", this.handleDocClick);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.handleDocClick);
    
    
  }
};
</script>

<style scoped>
/* dezente Hover-Hilfe für die Optionsliste */
.hover-bg:hover {
  background: rgba(0, 0, 0, 0.04);
}
/* kleinere Close-Buttons in Chips (falls Bootstrap nicht vorhanden) */
.btn-close-sm {
  transform: scale(0.8);
}

h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.form-check-input[type="checkbox"].form-check-input {
  width: 40px;
  height: 20px;
}

.form-check-input[type="checkbox"].form-check-input {
  margin-right: 10px;
  padding: 5px;
}

.bg-cs-color {
  background-color: #b9d1ff;
}

.spanField {
  border-radius: 10px 10px 0 0;
}

.spanSelectField {
  border-radius: 0 10px 10px 10px;
  border-width: 1px;
  border-color: #DDD1C5
}

.spanSelectField:focus {
  outline: none;
  border-color: #c2ab9282;
  box-shadow: 0 0 5px #c2ab9282;
}

.flip-card-3D-wrapper {
  perspective: 1000px;
}

.card {
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin: 5px;
  text-align: center;
  transform-style: preserve-3d;
  transition: transform 0.5s;
  display: flex;
}

.card.is-flipped {
  transform: rotateY(180deg);
}

.card-front,
.card-back {
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.card-back {

  transform: rotateY(180deg);
  position: absolute;
}

.label-data-front {
  color: #999
}

@media (min-width: 992px) {
  .custom-width-desktop {
    width: 25%;
  }
}

.scrolly {
  max-height: 900;
  overflow-y: auto;
  border: 1px solid #ccc;
}

.icon-margin-right {
  margin-right: 8px;
  
}

.loading-spinner {
  border: 16px solid #f3f3f3;
  border-top: 16px solid #c2ab9282;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: spin 2s linear infinite;
  margin: auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.shop-info {
  text-align: left;
}

.scrollable-div::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}


.scrollable-div::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
  border: 3px solid #f1f1f1;
}


.scrollable-div::-webkit-scrollbar {
  width: 12px;
}

.scrollable-div {
  scrollbar-width: thin;
  scrollbar-color: #888 #f1f1f1;
}

.scrollable-container {
  height: auto !important;
  overflow-y: visible;
  position: static;
}

@media (min-width: 992px) {
  .scrollable-container {
    overflow-y: auto;
    position: sticky;
    top: 0px;
  }
}

.btn12 {
  background-color: #fa890052;
  border: 1px solid #222 !important;
}



#slider,
#saugleistung-slider {
  width: clamp(260px, 90%, 520px);
  margin-inline: auto;
  display: block; 
  padding-inline: 12px; 
  box-sizing: border-box;
}
</style>

